import { render, staticRenderFns } from "./GithubButton.vue?vue&type=template&id=b110032a&scoped=true"
import script from "./GithubButton.vue?vue&type=script&lang=js"
export * from "./GithubButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b110032a",
  null
  
)

export default component.exports